import React from "react";
import { Avatar, Badge, Button, Dropdown, Menu, Space, Typography } from "antd";
import { BellOutlined, DownOutlined, LogoutOutlined, MenuOutlined, UserOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from "../../auth/session";

export default function Header({ onMenuClick }) {
  const { user, signOut } = useAuth();
  const history = useHistory();
  const pageLabel = { "/system/users": "Quản lý người dùng", "/bank-accounts": "Tài khoản ngân hàng", "/devices": "Quản lý tài nguyên" }[useLocation().pathname];
  const displayName = user?.displayName || user?.username || "Tài khoản";
  const initials = displayName.trim().charAt(0).toUpperCase();
  const accountMenu = (
    <Menu onClick={({ key }) => {
      if (key === "account") history.push("/account/me");
      if (key === "logout") signOut();
    }}>
      <Menu.Item key="account" icon={<UserOutlined />}>Thông tin tài khoản</Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout" icon={<LogoutOutlined />}>Đăng xuất</Menu.Item>
    </Menu>
  );
  return (
    <header className="app-header">
      <Space>
        <Button className="mobile-menu-button" type="text" icon={<MenuOutlined />} onClick={onMenuClick} aria-label="Mở trình đơn" />
        {pageLabel ? <div className="management-breadcrumb">Quản trị <span>/</span><strong>{pageLabel}</strong></div> : <Typography.Text strong>Quản lý tài khoản ngân hàng</Typography.Text>}
      </Space>
      <Space size={16}>
        {!pageLabel && <><Badge dot offset={[-3, 4]}><Button className="header-icon-button" type="text" icon={<BellOutlined />} aria-label="Thông báo" /></Badge><span className="header-divider" /></>}
        <Dropdown overlay={accountMenu} trigger={["click"]} placement="bottomRight">
          <Button className="header-account" type="text">
            <Avatar size={34}>{initials}</Avatar>
            <span className={pageLabel ? "management-profile" : ""}>{displayName}{pageLabel && <small>{({ SUPER_ADMIN: "Super Admin", ADMIN: "Admin", OPERATOR: "Operator", AUDITOR: "Auditor" })[user?.role]}</small>}</span>
            <DownOutlined className="header-chevron" />
          </Button>
        </Dropdown>
      </Space>
    </header>
  );
}

